export default {
  England: [
    'Bedfordshire',
    'Berkshire',
    'Bristol',
    'Buckinghamshire',
    'Cambridgeshire',
    'Cheshire',
    'Cornwall',
    'Cumbria',
    'Derbyshire',
    'Devon',
    'Dorset',
    'Durham',
    'East Sussex',
    'Essex',
    'Gloucestershire',
    'Greater London',
    'Greater Manchester',
    'Hampshire',
    'Herefordshire',
    'Hertfordshire',
    'Isle of Wight',
    'Kent',
    'Lancashire',
    'Leicestershire',
    'Lincolnshire',
    'City of London',
    'Merseyside',
    'Norfolk',
    'Northamptonshire',
    'Northumberland',
    'North Yorkshire',
    'Nottinghamshire',
    'Oxfordshire',
    'Rutland',
    'Shropshire',
    'Somerset',
    'South Yorkshire',
    'Staffordshire',
    'Suffolk',
    'Surrey',
    'Tyne and Wear',
    'Warwickshire',
    'West Midlands',
    'West Sussex',
    'West Yorkshire',
    'Wiltshire',
    'Worcestershire',
    'Yorkshire, East Riding',
  ],
  'Northern Ireland': [
    'Antrim',
    'Armagh',
    'City of Belfast',
    'Down',
    'Fermanagh',
    'Londonderry',
    'City of Derry',
    'Tyrone',
  ],
  Scotland: [
    'City of Aberdeen',
    'Aberdeenshire',
    'Angus (Forfarshire)',
    'Argyll',
    'Ayrshire',
    'Banffshire',
    'Berwickshire',
    'Bute',
    'Caithness',
    'Clackmannanshire',
    'Dumfriesshire',
    'Dunbartonshire (Dumbarton)',
    'City of Dundee',
    'East Lothian (Haddingtonshire)',
    'City of Edinburgh',
    'Fife',
    'City of Glasgow',
    'Inverness-shire',
    'Kincardineshire',
    'Kinross-shire',
    'Kirkcudbrightshire',
    'Lanarkshire',
    'Midlothian (County of Edinburgh)',
    'Moray (Elginshire)',
    'Nairnshire',
    'Orkney',
    'Peeblesshire',
    'Perthshire',
    'Renfrewshire',
    'Ross and Cromarty',
    'Roxburghshire',
    'Selkirkshire',
    'Shetland (Zetland)',
    'Stirlingshire',
    'Sutherland',
    'West Lothian (Linlithgowshire)',
    'Wigtownshire',
  ],
  Wales: [
    'Isle of Anglesey',
    'Cardiganshire',
    'Carmarthenshire',
    'Clwyd',
    'Denbighshire',
    'Dyfed',
    'Flintshire',
    'Gwent',
    'Gwynedd',
    'Mid Glamorgan',
    'Monmouthshire',
    'Pembrokeshire',
    'Powys',
    'South Glamorgan',
    'West Glamorgan',
    'Wrexham',
  ],
}
